export function formatDate (dateStr) {
  let result = ''
  try {
    result = this.$moment(dateStr).format('YYYY-MM-DD HH:mm:ss')
  } catch (e) {
    console.log(e)
  }
  return result
}
